/* Categorie Home DR - Digital Runner
   - pannello categorie: si apre sotto la riga della categoria cliccata
   - apri/chiudi griglia su mobile
   - desktop: categorie su una riga; se non ci stanno (nome che esce dal box o box troppo
     stretti, es. portatili a 1024px) la sezione passa alla modalita' compatta come su mobile
   - frecce del carosello "Articoli di tendenza"
   - tastiera sul pulsante <add-to-cart> di Be Yours
   Supporta piu' sezioni nella stessa pagina e il ricaricamento nel customizer. */
(function () {
  function init(root) {
    if (!root || root.dataset.hcReady) return;
    root.dataset.hcReady = '1';

    var grid = root.querySelector('.hc__grid_dr');
    var toggle = root.querySelector('.hc__toggle_dr');
    var openId = null;
    var panelEl = null;

    function tiles() {
      return grid ? Array.prototype.slice.call(grid.querySelectorAll('.hc__tile_dr')) : [];
    }

    // Una riga o modalita' compatta? (decisione comune a tutte le sezioni categorie della pagina)
    function fit() { fitAll(); }
    fit();
    // i font arrivano dopo: ricontrollo quando sono pronti
    if (document.fonts && document.fonts.ready) document.fonts.ready.then(fit);

    function closePanel() {
      if (panelEl) panelEl.remove();
      panelEl = null;
      openId = null;
      tiles().forEach(function (t) { t.setAttribute('aria-expanded', 'false'); });
    }

    function openPanel(tile) {
      var id = tile.dataset.panel;
      var tpl = root.querySelector('template[data-panel-tpl="' + id + '"]');
      if (!tpl) return;
      closePanel();

      // ultima categoria della stessa riga visiva
      var all = tiles();
      var top = tile.offsetTop;
      var last = tile;
      all.forEach(function (t) { if (t.offsetTop === top) last = t; });

      panelEl = tpl.content.firstElementChild.cloneNode(true);
      last.insertAdjacentElement('afterend', panelEl);

      // freccia del pannello centrata sulla categoria
      var gridLeft = grid.getBoundingClientRect().left;
      var r = tile.getBoundingClientRect();
      panelEl.style.setProperty('--hc-notch', (r.left - gridLeft + r.width / 2 - 8) + 'px');

      tile.setAttribute('aria-expanded', 'true');
      openId = id;
    }

    if (grid) {
      grid.addEventListener('click', function (e) {
        var tile = e.target.closest('.hc__tile_dr');
        if (!tile) return;
        if (openId === tile.dataset.panel) closePanel(); else openPanel(tile);
      });

      // al cambio di larghezza le righe cambiano: riposiziona il pannello aperto
      var rt;
      window.addEventListener('resize', function () {
        clearTimeout(rt);
        rt = setTimeout(function () {
          fit();
          if (!openId) return;
          var t = grid.querySelector('.hc__tile_dr[data-panel="' + openId + '"]');
          if (t) openPanel(t);
        }, 150);
      });

      root.addEventListener('keydown', function (e) {
        if (e.key === 'Escape' && openId) {
          var t = grid.querySelector('.hc__tile_dr[data-panel="' + openId + '"]');
          closePanel();
          if (t) t.focus();
        }
      });
    }

    if (toggle && grid) {
      toggle.addEventListener('click', function () {
        var open = grid.getAttribute('data-open') === 'true';
        grid.setAttribute('data-open', open ? 'false' : 'true');
        toggle.setAttribute('aria-expanded', open ? 'false' : 'true');
        if (open) closePanel();
      });
    }

    // Carosello
    var track = root.querySelector('[data-hc-track]');
    var prev = root.querySelector('.hc__arrow_dr--prev');
    var next = root.querySelector('.hc__arrow_dr--next');
    var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    function scrollTrack(dir) {
      if (!track) return;
      track.scrollBy({ left: dir * track.clientWidth * 0.8, behavior: reduce ? 'auto' : 'smooth' });
    }
    if (prev) prev.addEventListener('click', function () { scrollTrack(-1); });
    if (next) next.addEventListener('click', function () { scrollTrack(1); });

    // <add-to-cart> di Be Yours gestisce solo il click: aggiungo Invio / Spazio
    root.addEventListener('keydown', function (e) {
      var btn = e.target.closest && e.target.closest('add-to-cart.hc__add_dr');
      if (btn && (e.key === 'Enter' || e.key === ' ')) {
        e.preventDefault();
        btn.click();
      }
    });

    // Customizer: selezionando un blocco categoria si apre il suo pannello
    root.addEventListener('shopify:block:select', function (e) {
      var t = e.target.closest && e.target.closest('.hc__tile_dr');
      if (!t) return;
      if (grid) grid.setAttribute('data-open', 'true');
      if (toggle) toggle.setAttribute('aria-expanded', 'true');
      openPanel(t);
    });
  }

  // Desktop: categorie su una riga. Se in UNA delle sezioni della pagina non ci stanno
  // (box sotto i 84px, nome che esce dal box o riga che sborda) tutte passano alla modalita'
  // compatta, cosi' le sezioni una sopra l'altra si comportano allo stesso modo.
  var MOBILE = 700;   // sotto questa larghezza decide il CSS mobile
  var MIN_TILE = 84;  // larghezza minima di un box (icona 64px + margini)
  function fitAll() {
    var roots = Array.prototype.slice.call(document.querySelectorAll('[data-hc]'));
    var compact = false;
    roots.forEach(function (r) {
      r.classList.remove('is-compact');
      var g = r.querySelector('.hc__grid_dr');
      if (!g) return;
      var ts = g.querySelectorAll('.hc__tile_dr');
      g.style.setProperty('--hc-n', ts.length || 8);
    });
    if (window.innerWidth > MOBILE) {
      roots.forEach(function (r) {
        var g = r.querySelector('.hc__grid_dr');
        if (!g) return;
        Array.prototype.forEach.call(g.querySelectorAll('.hc__tile_dr'), function (t) {
          var nm = t.querySelector('.hc__name_dr');
          if (t.offsetWidth < MIN_TILE) compact = true;
          if (nm && nm.scrollWidth > nm.clientWidth + 1) compact = true;
        });
        if (g.scrollWidth > g.clientWidth + 1) compact = true;
      });
    }
    if (compact) roots.forEach(function (r) { r.classList.add('is-compact'); });
  }

  function initAll() {
    document.querySelectorAll('[data-hc]').forEach(init);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }

  document.addEventListener('shopify:section:load', function (e) {
    init(e.target.querySelector('[data-hc]'));
  });
})();
